<div [class]="skinName">
    @if (paymentGateway === 'stripe') {
        <div id="pay-method">
            <div class="d-flex">
                <img id="ideal-logo"  alt="ideal-logo" src="branding/theme/assets/static_assets/ic-ideal.svg">
            </div>
            <app-ideal-pay page="auth"></app-ideal-pay>
            <button id="continue-btn" (click)="proceedPayment()">{{configService.localeKeys?.['downloads.continue.text']}}</button>
        </div>
        <app-stripe-info></app-stripe-info>
    } @else if (paymentGateway === 'adyen') {
        <div id="adyen-ideal-container"></div>
    }
</div>